<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="otDetail d-flex j-sb">
					<!-- 左侧详情 -->
					<div class="otLeftContent">
						<!-- 视频区 -->
						<div class="tVideo bd10 p3">
							<div class="tagList">
								<i v-for="(t,index) in content.subGroup ? content.subGroup.split(',') : []" :key="index">{{t}}</i>
							</div>
							<h3 class="font30 line-sm">{{content.title}}</h3>
							<div class="tagList">
								<span class="font-light cor999">{{content.time}}&emsp;{{$t('activity.resource')}}：{{content.origin}}</span>
							</div>
							<div class="dImg line-md" v-html="content.content"></div>
						</div>
						<!-- 上下篇 -->
						<div class="pageTurning bd10 p3 d-flex j-sb">
							<p class="font-light cor999 d-flex" v-if="content.prev" @click="goToPage('/activityDetail?id='+content.prev.id)">{{$t('show.prev')}} - <a class="link pointer nowrap1">{{content.prev.title}}</a></p>
							<p class="font-light cor999 d-flex" v-if="content.next" @click="goToPage('/activityDetail?id='+content.next.id)"><a class="link pointer nowrap1">{{content.next.title}}</a> - {{$t('show.next')}}</p>
						</div>
					</div>
					<!-- 右侧目录菜单 -->
					<div class="otRightMenu">
						<div class="atForm bd10">
							<div class="afTop t-center">
								<h3 class="h3 font30 font-medium">{{$t('activity.eventRegistration')}}</h3>
								<p class="font-light">{{$t('activity.tip')}}</p>
								<p class="bei d-flex j-center font-light"><span>{{$t('activity.requireTip')}}</span></p>
							</div>
							<div class="form">
								<dl>
									<dd class="d-flex f-colu">
										<div class="font18 label">* {{$t('activity.name')}}</div>
										<div class="enter">
											<input type="text" v-model="formData.realName" class="input font-light font18" :placeholder="$t('activity.name')">
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="font18 label">* {{$t('activity.phone')}}</div>
										<div class="enter d-flex j-sb a-center select">
											<select name="" id="" class="input">
												<option value="+86">+86</option>
											</select>
											<input type="text" v-model="formData.mobile" class="input font-light font18" :placeholder="$t('activity.phone')">
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="font18 label">* {{$t('activity.email')}}</div>
										<div class="enter">
											<input type="text" @keyup="ruleEmailStyle" v-model="formData.email" class="input font-light font18" :placeholder="$t('activity.email')">
											<span class="tipSpan d-block" v-show="isEmail">{{$t('activity.emailRex')}}</span>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="font18 label">* {{$t('activity.company')}}</div>
										<div class="enter">
											<input type="text" v-model="formData.company" class="input font-light font18" :placeholder="$t('activity.company')">
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="font18 label">{{$t('activity.post')}}</div>
										<div class="enter">
											<select name="" v-model="formData.job" id="" class="input font-light font18">
												<option value="">{{$t('activity.selectPost')}}</option>
												<option :value="o.value" v-for="(o,index) in jobOptions" :key="index">{{o.label}}</option>
											</select>
										</div>
									</dd>
									<dd class="d-flex f-colu">
										<div class="font18 label">* {{$t('activity.industry')}}</div>
										<div class="enter">
											<select name="" v-model="formData.industry" id="" class="input font-light font18">
												<option value="">{{$t('activity.selectIndustry')}}</option>
												<option :value="o.value" v-for="(o,index) in industryOptions" :key="index">{{o.label}}</option>
											</select>
										</div>
									</dd>
								</dl>
								<p class="d-flex a-center"><span @click="isAgree = !isAgree" :class="['pointer checkbox', {active: isAgree}]"></span>{{$t('activity.aggree')}}<a @click="handelPopup = !handelPopup" class="corfff pointer">《{{AggreeContent.title}}》</a></p>
								<div class="submit"><button class="pointer fmBtn" @click="nowEntry">{{$t('activity.submit')}}</button></div>
							</div>
						</div>
					</div>
				</div>
				<!-- 用户协议 -->
				<div :class="['userProtocol d-flex a-center j-center', {active: handelPopup}]">
				   <div class="w1600">
					   <div class="userContent pr">
						   <p class="close pointer d-flex a-center cor666 font18" @click="handelPopup = !handelPopup"><img src="@/assets/Icons/closeNew.png" alt="">{{$t('activity.close')}}</p>
						   <h3 class="h3 font30 font-alimama">{{AggreeContent.title}}</h3>
						   <div class="text line-md cor666" v-html="AggreeContent.content"></div>
						   <div class="fmBtn pointer" @click="isAgree = true;handelPopup = false;">{{$t('activity.aggreed')}}</div>
					   </div>
				   </div>
				</div>
			</div>
		</div>
		<!-- 弹窗提示 -->
		<popup v-show="popupHandle">
			<div class="slot d-flex f-colu j-center a-center line-md">
				<img src="@/assets/Icons/error.png" alt="">
				<div class="required font18" v-html="message"></div>
			</div>
		</popup>
  </div>
</template>

<script>
// 邮箱验证
let ruleEmail = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
export default {
  name: 'ActivityDetail',
  components: {
    
  },
  data() {
    return {
		// 控制注册协议显示/隐藏
		handelPopup: false,
		// 详细信息
		content: {},
		// 同意协议
		isAgree: false,
		message: '', // 提示
		popupHandle: false, // 控制提示弹窗是否显示
		isEmail: false, // 邮箱验证是否显示
		jobOptions:[],
		industryOptions:[],
		AggreeContent:'',
		// 表单信息
		formData: {
			activityId: 0, // 当前活动id
			realName: '', // 姓名
			mobile: '', // 手机号
			email: '', // 邮箱
			company: '', // 公司名称
			job: '', // 职位
			industry: '', // 行业
		}
	}
  },
  
  created() {
  	  // 获取详细信息
	  this.getOptions();
	  this.getAggreeContent();
  	  this.getContentInfo(this.$route.query.id);
	  this.formData.activityId = this.$route.query.id;
  	 
  },
  
  methods: {
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  			path,
  			query
  		  })
  	  },
	  getAggreeContent(){
		var that=this;
		this.$axios.get('index/content/details?id=22')
  		  .then(res => {
  			  that.AggreeContent=res.data;
  		  }).catch(err=>{});
	  },
  	  getOptions(){
		var that=this;
		this.$axios.get('common/getDict?dictType=sys_activity_job')
  		  .then(res => {
  			  that.jobOptions=res.data;
  		  }).catch(err=>{});
		this.$axios.get('common/getDict?dictType=sys_activity_industry')
  		  .then(res => {
  			  that.industryOptions=res.data;
  		  }).catch(err=>{})
	  },
  	  // 获取详细信息
  	  getContentInfo(id) {
  		  this.$axios.get(`activity/details?id=${id}`)
  		  .then(res => {
  			  let data = res.data;
  			  // 当前产品信息
  			  this.content = data;
			  document.title = data.title;
  		  })
  		  .catch(err=>{})
  	  },
	  
	  // 邮箱输入框离开时验证格式
	  ruleEmailStyle() {
		  this.isEmail = !ruleEmail.test(this.formData.email) ? true : false;
	  },
	  
	  // 立即报名
	  nowEntry() {
		  // 第一步先验证活动是否已经结束
		  if(this.content.applyType == 3) {
			  this.popupHandle = true;
			  this.message = this.$t('activity.activityEnded');
			  return;
		  }
		  let index = 0;
		  let requred = '';
		  // 姓名
		  if(!this.formData.realName.trim()) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('activity.namePlaceholder')+'</p>';
		  }
		  // 手机号
		  if(!this.formData.mobile.trim()) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('activity.phonePlaceholder')+'</p>';
		  }
		  // 企业邮箱
		  if(!this.formData.email.trim()) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('activity.emailPlaceholder')+'</p>';
		  }
		  // 公司
		  if(!this.formData.company.trim()) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('activity.companyPlaceholder')+'</p>';
		  }
		  // 行业
		  if(!this.formData.industry) {
			  index++;
			  requred+='<p>'+index + ' - ' + this.$t('activity.selectIndustry')+'</p>';
		  }
		  if(index > 0) {
			  this.popupHandle = true;
			  this.message = requred;
			  return;
		  }
		  // 单独进行邮箱验证
		  if(!ruleEmail.test(this.formData.email)) {
			 this.popupHandle = true;
			 this.message = this.$t('activity.emailRex');
			  return;
		  }
		  if(!this.isAgree) {
			  this.popupHandle = true;
			  this.message = this.$t('activity.pleaseRead')+'《'+this.AggreeContent.title+'》';
			  return;
		  }
		  // 可以提交了
		  this.$axios.post('form/activity/apply', this.formData)
		  .then(res => {
			  this.$message.success(this.$t('activity.success'));
			  // 表单重置
			  this.formData.realName = ''; // 姓名
			  this.formData.mobile = ''; // 手机号
			  this.formData.email = ''; // 邮箱
			  this.formData.company = ''; // 公司名称
			  this.formData.job = ''; // 职位
			  this.formData.industry = ''; // 行业
			  this.isAgree = false; // 协议
		  })
		  .catch(err => {})
	  }
	},
	
	// 监听
	watch: {
		  // 路由变化
		  '$route'(to, from) {
			  // 重新获取详细信息
			  this.getContentInfo(this.$route.query.id);
		  } 
	}
}
</script>

<style lang="less" scoped>
	.otDetail{
		padding-top: .6rem;
		align-items: flex-start;
		.otLeftContent{
			width: 66.875%;
		}
		.otRightMenu{
			width: 31.875%;
			position: sticky;
			top: 0;
		}
		@media (max-width: 1200px) {
			flex-direction: column;
			.otLeftContent,
			.otRightMenu{
				width: 100%;
			}
				
			.otRightMenu{
				margin-top: .3rem;
			}
		}
	}
	.userProtocol{
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
		background: rgba(0, 0, 0, .8);
		z-index: 30;
		padding: 0.5rem;
		display: none;
	}
	.userProtocol.active{
		display: flex;
	}
	.userProtocol .userContent{
		padding: 0.3rem;
		padding-top: 0.8rem;
		background: #fff;
		border-radius: 0.15rem;
		width: 100%;
		overflow: hidden;
		.fmBtn{
			width: 90%;
			max-width: 200px;
			margin: 0 auto;
		}
	}
	.userProtocol .userContent h3{
		text-align: center;
		margin-bottom: 0.3rem;
	}
	.userProtocol .userContent .text{
		overflow: auto;
		max-height: 80vh;
		min-height: 40vh;
	}
	.userProtocol .userContent .close{
		position: absolute;
		right: 0;
		top: 0;
		padding: 0.15rem 0.2rem;
		border: solid 1px #ddd;
		border-bottom-left-radius: 0.15rem;
	}
	.userProtocol .userContent .close img{
		width: 0.2rem;
		margin-right: 5px;
	}
	.otRightMenu{
		.atForm{
			background: #263c93;
			color: #fff;
			padding: .3rem .7rem .6rem;
			@media (max-width: 1600px) {
				padding-left: .3rem;
				padding-right: .3rem;
			}
		}
		.form{
			.submit{
				button{
					display: block;
					width: 100%;
					background: none;
					border: solid 2px #fff;
					&:hover{
						box-shadow: none;
						background-color: #fff;
						color: #263c93;
					}
				}
			}
			.tipSpan{
				margin: 5px 0 0 .2rem;
				color: #d01111;
			}
			p{
				margin: .2rem 0 .4rem;
				
				a:hover{
					text-decoration: underline !important;
				}
			}
			dl{
				dd{
					margin-top: .2rem;
					.input{
						background-color: #fff;
					}
					.select{
						select{
							width: 1rem;
							background-position-x: 85%;
							padding-right: .3rem;
						}
						input{
							width: calc(100% - 1.2rem);
						}
					}
					.label{
						margin-bottom: .1rem;
					}
				}
			}
		}
		.afTop{
			p:nth-of-type(1) {
				margin: .15rem 0 .2rem;
			}
			.bei span{
				padding: 0 .15rem;
				background: url(@/assets/Icons/disc.png) no-repeat 0 center/.1rem, url(@/assets/Icons/disc.png) no-repeat right center/.1rem;
				color: #b8e0ff;
			}
		}
	}
	.otLeftContent{
		& > div:not(:last-child){
			margin-bottom: .1rem;
		}
		.tVideo{
			padding-top: .4rem;
			padding-bottom: .6rem;
			.dImg{
				padding-top: .4rem;
				margin-top: .4rem;
				border-top: solid 1px #eee;
				min-height: 5rem;
			}
			h3{
				margin: .15rem 0 .2rem;
			}
			i{
				margin-right: .2rem;
			}
		}
		@media (max-width: 1200px) {
			.tVideo{
				.dImg{
					min-height: 2rem;
				}
			}
		}
	}
</style>
